module.exports = __webpack_public_path__ + "img/galleria9.a6223bed.jpg";